export const dialogs = {
    'account.title': 'My account',
    'account.operator': 'Provider',
    'account.changePassword': 'Change password',
    'account.currentPassword': 'Current password',
    'account.newPassword': 'New password',
    'account.repeat': 'Once more',
    'account.minLength': 'At least 10 characters.',
    'account.mismatch': 'The two new passwords do not match.',
    'account.changeFailed': 'The change failed.',
    'account.changed': 'Password changed.',
    'account.signOutHint': 'Changing it signs out every signed-in device. This one stays signed in.',
    'account.languageHint': 'Applies on every device you sign in on.',
    'admin.loadFailed': 'The overview could not be loaded.',
    'admin.changeFailed': 'The change failed.',
    'admin.createFailed': 'Creating failed.',
    'admin.deleteFailed': 'Deleting failed.',
    'admin.deletePrompt': 'Everything belonging to “{org}” will be deleted: {boards}, {storage} of media, {members} accounts.\n\nThis cannot be undone — only via the nightly backup.\n\nType the name to confirm:',
    'admin.deleted': '“{org}” was deleted.',
    'admin.board.one': '{count} board',
    'admin.board.many': '{count} boards',
    'admin.daysLeft': '{days} d left',
    'admin.daysSince': '{days} d ago',
    'admin.noAdmins': 'nobody in administration yet',
    'admin.people': 'people',
    'admin.priceTitle': 'List price of this plan. Invoicing is done manually.',
    'admin.onRequest': 'on request',
    'admin.until': 'Valid until',
    'admin.untilTitle': 'Leave empty = unlimited',
    'admin.untilHint': 'Leave empty for unlimited.',
    'admin.extend': '+1 year',
    'admin.extendTitle': 'Extend the term by one year',
    'admin.addCustomer': 'Add customer',
    'admin.orgPlaceholder': 'Example Ltd',
    'team.orgName': 'Name of the organisation',
    'team.addPerson': 'Add person',
    'team.add': 'Add',
    'team.role': 'Role',
    'team.addFailed': 'Adding failed.',
    'team.roleFailed': 'The role could not be changed.',
    'team.removeFailed': 'Removing failed.',
    'team.pendingTitle': 'Invited, has not opened the link yet',
    'team.withdrawInvite': 'Withdraw invitation',
    'team.removeFromOrg': 'Remove from the organisation',
    'team.mailPlaceholder': 'name@company.com',
    'team.addHint': 'They receive an invitation and set their own password. If an account already exists for that address, they join right away.',
    'team.invited': 'Invitation sent to {email}. They set their own password.',
    'team.alreadyExisted': '{name} has joined — the account already existed.',
    'team.removed': '{name} removed.',
    'team.removedWithBoards': '{name} removed. {boards} have been handed over to you.',
    'team.board.one': '{count} board',
    'team.board.many': '{count} boards',
    'team.inviteMailFailed': 'The invitation email could not be sent. Please pass this link on yourself:',
    'share.tabTeam': 'In the team',
    'share.tabGuests': 'For guests',
    'share.teamLead': 'A board is private at first. Anyone who should work on it gets it here — with full editing rights.',
    'share.accessLoadFailed': 'Access rights could not be loaded.',
    'share.changeFailed': 'The change failed.',
    'share.visibility': 'Visibility',
    'share.privateHint': 'Only the owner and people added explicitly.',
    'share.orgHint': 'Every member of the organisation finds the board in their overview.',
    'share.owner': 'Owner',
    'share.withdraw': 'Withdraw access',
    'share.withdrawFor': 'Withdraw access for {name}',
    'share.addPerson': 'Add person',
    'share.choosePerson': 'Choose from the organisation …',
    'share.orgOpenHint': 'As long as the board is open to the organisation, this list is only a reminder — everyone can see it anyway.',
    'share.ownerOnly': 'Access can be changed by the owner or the administration.',
    'share.guestLead': 'Anyone with the link sees the board — without signing in and read-only. How much they can steer themselves is set by the mode.',
    'share.mode': 'Sharing mode',
    'share.greeting': 'Greeting on the waiting screen',
    'share.optional': '(optional)',
    'share.greetingPlaceholder': 'Kickoff Example Ltd — we start at 2 pm.',
    'share.noWaitingHint': 'Free viewing has no waiting screen — the guest sees the board immediately. The greeting would go unread.',
    'share.createLink': 'Create link',
    'share.creating': 'Creating …',
    'share.previewWaiting': 'View waiting screen',
    'share.closePreview': 'Close preview',
    'share.noLinks': 'No link created yet.',
    'share.revoke': 'Revoke',
    'templates.applyTitle': 'Insert template',
    'templates.saveTitle': 'Save as template',
    'templates.loadFailed': 'Templates could not be loaded.',
    'templates.applyFailed': 'The template could not be inserted.',
    'templates.saveFailed': 'The template could not be saved.',
    'templates.delete': 'Delete template',
    'templates.deleteLabel': 'Delete template {name}',
    'templates.elements.one': '{count} element',
    'templates.elements.many': '{count} elements',
    'templates.saveCount.one': '{count} element will be saved with it.',
    'templates.saveCount.many': '{count} elements will be saved with it.',
    'templates.copying': 'Copying template …',
    'templates.scope': 'Scope',
    'templates.save': 'Save template',
    'templates.saving': 'Saving …',
    'boardTemplates.applyTitle': 'Insert board template',
    'boardTemplates.applyLead': 'A skeleton creates empty frames — arrangement and order, no content. On a board that already has frames, it is placed to the right and at the end of the presentation order.',
    'boardTemplates.loadFailed': 'Board templates could not be loaded.',
    'boardTemplates.applyFailed': 'The skeleton could not be inserted.',
    'boardTemplates.applying': 'Inserting skeleton …',
    'boardTemplates.saveFailed': 'The skeleton could not be saved.',
    'boardTemplates.delete': 'Delete board template',
    'boardTemplates.deleteLabel': 'Delete board template {name}',
    'boardTemplates.frame.one': '{count} frame',
    'boardTemplates.frame.many': '{count} frames',
    'boardTemplates.noFrames': 'This board has no frames yet.',
    'boardTemplates.fromBoard': 'From this board',
    'boardTemplates.fromBoardTitle': 'Save the frames of this board as a skeleton — without their content',
    'boardTemplates.compose': 'Compose a new one',
    'boardTemplates.saveTitle': 'Save as board template',
    'boardTemplates.saveLead': 'What is saved is the skeleton: position, size and order of the frames. Whatever lies inside them — images, text, websites — stays out.',
    'boardTemplates.namePlaceholder': 'e.g. Client meeting',
    'boardTemplates.included': 'What comes along',
    'boardTemplates.withNames': 'Names of the frames',
    'boardTemplates.withNamesHint': ' — otherwise “Frame 1”, “Frame 2” …',
    'boardTemplates.withStyle': 'Styling',
    'boardTemplates.withStyleHint': ' — background, border, margins and grid',
    'boardTemplates.withNotes': 'Speaker notes',
    'boardTemplates.notesNone': ' — none saved',
    'boardTemplates.notesSome': ' — {noted} of {total} frames have one',
    'boardTemplates.notesUnavailable': ' — not available',
    'boardTemplates.inSkeleton': '{frames} in the skeleton.',
    'boardTemplates.save': 'Save board template',
    'boardTemplates.composeTitle': 'Compose board template',
    'boardTemplates.composePlaceholder': 'e.g. Weekly round',
    'boardTemplates.layout': 'Arrangement',
    'boardTemplates.frames': 'Frames',
    'boardTemplates.columns': 'Columns',
    'boardTemplates.oneRow': 'One row',
    'boardTemplates.format': 'Format',
    'boardTemplates.labels': 'Labels',
    'theme.title': 'Board design',
    'theme.lead': 'Applies to this board and everyone working on it. The house colours then come first in every colour picker.',
    'theme.background': 'Background',
    'theme.backgroundLabel': 'Backdrop',
    'theme.palette': 'House colours',
    'theme.color': 'Colour {number}',
    'theme.headings': 'Headings',
    'theme.body': 'Body text',
    'theme.reset': 'Adopt the default of {org}',
    'theme.resetTitle': 'Set backdrop, house colours and fonts to the organisation’s default',
    'design.title': 'Design · {org}',
    'design.lead': 'What new boards of this organisation start with. Existing boards stay as they are.',
    'design.previewBody': 'Body text, as it appears on new boards.',
    'design.save': 'Save as default',
    'design.saving': 'Saving …',
    'design.saved': 'Saved',
    'design.saveFailed': 'Saving failed.',
    'design.adminOnly': 'Only the administration can change the default design.',
    'design.logo': 'Logo',
    'design.logoHint': 'Appears on the waiting screen guests see before a presentation starts. SVG, PNG or WebP, at most 512 KB — ideally cut out with a transparent background. An SVG stays sharp at any size.',
    'design.logoAlt': 'Logo of {org}',
    'design.noLogo': 'No logo',
    'design.chooseLogo': 'Choose logo',
    'design.replace': 'Replace',
    'design.logoFailed': 'The logo could not be set.',
    'design.logoRemoveFailed': 'The logo could not be removed.',
    'design.fonts': 'Fonts',
    'fonts.builtIn': 'Built in',
    'fonts.added': 'Added',
    'fonts.addGoogle': 'Add a font from Google Fonts',
    'fonts.googlePlaceholder': 'e.g. Inter, Playfair Display …',
    'fonts.fetch': 'Fetch',
    'fonts.loading': 'Loading …',
    'fonts.googleHint': 'The font is fetched once and served from this server afterwards — so it is there during a talk even without internet. It belongs to this organisation.',
    'fonts.uploadOwn': 'Upload your own font file',
    'fonts.uploadHint': 'WOFF2, OTF or TTF, at most {limit}. OTF and TTF are converted to WOFF2 on upload. Upload one file each for regular and bold — both under the same name make up one font.',
    'fonts.namePlaceholder': 'Name of the font',
    'fonts.regular': 'Regular',
    'fonts.bold': 'Bold',
    'fonts.upright': 'Upright',
    'fonts.italic': 'Italic',
    'fonts.licenseConfirm': 'The licence of this font permits embedding on a web server (webfont rights).',
    'fonts.upload': 'Upload',
    'fonts.fetchFailed': 'The font could not be fetched.',
    'fonts.uploadFailed': 'The font could not be uploaded.',
    'fonts.removeFailed': 'Removing failed.',
    'fonts.fromProvider': 'from the provider',
    'fonts.ownFile': 'own file',
    'color.pick': 'Choose colour',
    'color.boardColors': 'Board colours',
    'color.suggestions': 'Suggestions',
    'color.none': 'No colour',
    'color.custom': 'Custom',
    'newBoard.title': 'New board',
    'newBoard.defaultTitle': 'New board',
    'newBoard.failed': 'The board could not be created.',
    'newBoard.skeleton': 'Skeleton',
    'newBoard.empty': 'Empty board',
    'newBoard.emptyMeta': 'Without frames',
    'newBoard.skeletonHint': 'A skeleton creates empty frames — the stages of your talk. No content comes along.',
    'newBoard.titlePlaceholder': 'e.g. Client presentation Q3',
    'newBoard.titleHint': 'Without a name it is called “New board” — renaming works at any time.',
    'newBoard.accent': 'Accent colour',
    'newBoard.accentHint': 'Borders, highlights and the first choice in the colour picker.',
    'newBoard.previewHeading': 'Client presentation Q3',
    'newBoard.previewBody': 'Body text, as it appears on the board.',
    'newBoard.create': 'Create board',
    'newBoard.creating': 'Creating …',
    'history.title': 'Board history',
    'history.loadListFailed': 'The history could not be loaded.',
    'history.loadFailed': 'This state could not be loaded.',
    'history.loadingList': 'Loading history …',
    'history.loadingState': 'Loading state …',
    'history.empty': 'There are no saved states for this board yet. The first one appears as soon as you put something on it — after that one is captured every quarter of an hour.',
    'history.today': 'Today, {time}',
    'history.yesterday': 'Yesterday, {time}',
    'history.on': '{day}, {time}',
    'history.counts': '{elements} elements, {frames} frames',
    'history.beforeRestore': 'Before restoring',
    'history.confirm': 'The board will be reset to the state of {moment} — for everyone involved at once. The current state is saved beforehand.',
    'history.restore': 'Restore this state',
    'history.restoreConfirm': 'Yes, restore',
    'history.restoring': 'Restoring …',
    'history.restoreFailed': 'The state could not be restored.',
    'url.addTitle': 'Embed website',
    'url.editTitle': 'Change address',
    'url.address': 'Address',
    'url.incomplete': 'Please enter a complete address.',
    'url.httpsOnly': 'Only https addresses can be embedded.',
    'url.insert': 'Insert',
    'url.confirm': 'Apply',
    'url.placeholder': 'https://example.com',
    'url.embedHint': 'Some sites technically forbid embedding. Præsto then shows a note with a direct link instead of an empty frame.',
    'participants.title': 'Participants',
    'participants.one': '{count} participant',
    'participants.many': '{count} participants',
    'participants.inBoard': '{people} on the board',
    'participants.you': '(you)',
    'participants.presenting': 'presenting',
    'participants.watching': 'watching',
    'participants.editing': 'editing',
    'participants.following': 'following',
    'participants.lookingAround': 'looking around',
    'frames.empty': 'A frame captures the current view. The order here is the order of the presentation.',
    'frames.itemTitle': 'Click zooms to the frame · double-click renames it',
    'frames.note': 'Speaker note',
    'frames.noteTitle': 'Speaker note — only for you, never for guests',
    'frames.notePlaceholder': 'What you want to say about this frame. Only people who may edit the board see it.',
    'frames.drag': 'Drag to reorder · Alt+↑/↓ does the same without a mouse',
    'frames.delete': 'Delete frame',
    'layers.text': 'Text',
    'layers.media': 'Medium',
    'layers.forward': 'One layer forward',
    'layers.backward': 'One layer back',
    'layers.noFrame': 'Without frame',
    'layers.empty': 'Nothing on the board yet. Add something via “Media”, “Website” or “Text” above.',
};
//# sourceMappingURL=dialogs.js.map